import type { ConvexReactClientOptions } from 'convex/react';
import { reportConvexMalformedFrameFromLog } from './convex-realtime-frame-telemetry';
import { recordDeploySkewSignalFromLog } from './deploy-skew';

type ConvexLogger = Exclude<ConvexReactClientOptions['logger'], boolean>;

/**
 * Console logger matching Convex's default that also records a deploy skew
 * signal. The cached `usePaginatedQuery` reports an InvalidCursor only as a
 * warning before it resets, so this is where the boundary can learn of it.
 * It also reports the malformed-frame reconnect our Convex patch logs.
 */
export function createDeploySkewAwareConvexLogger(options: {
  verbose: boolean;
}): NonNullable<ConvexLogger> {
  return {
    logVerbose: (...args: unknown[]) => {
      if (options.verbose) console.debug(new Date().toISOString(), ...args);
    },
    log: (...args: unknown[]) => {
      reportConvexMalformedFrameFromLog(args);
      console.log(...args);
    },
    warn: (...args: unknown[]) => {
      recordDeploySkewSignalFromLog(args);
      console.warn(...args);
    },
    error: (...args: unknown[]) => {
      recordDeploySkewSignalFromLog(args);
      console.error(...args);
    },
  };
}
